import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { ValidationOptions } from 'react-hook-form/dist/types';
import { validateRequired } from 'utils/form';
import { Checkbox, FormControlLabel } from '@mui/material';
import { IMuiCheckboxProps } from 'components/base/mui-checkbox/MuiCheckbox';

import { useStyles } from './MuiCheckbox.styles';

interface IRegisteredMuiCheckboxProps extends IMuiCheckboxProps {
	validation?: ValidationOptions;
	required?: boolean;
}

export const RegisteredMuiCheckbox = ({
	name,
	wrapperClass,
	label = '',
	value,
	checked,
	onChange,
	disabled,
	labelPlacement,
	color = 'primary',
	validation = {},
	required,
	...props
}: IRegisteredMuiCheckboxProps) => {
	const classes = useStyles();
	const { t } = useTranslation('errors');

	const { register } = useFormContext();

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>, isChecked: boolean) => {
			if (onChange) {
				onChange(e, isChecked);
			}
		},
		[onChange],
	);

	return (
		<FormControlLabel
			className={wrapperClass}
			label={label}
			labelPlacement={labelPlacement}
			inputRef={register({
				...validateRequired(required, t('required')),
				...validation,
			})}
			value={onChange ? value : undefined}
			checked={onChange ? !!value : undefined}
			control={
				<Checkbox
					className={classes.checkbox}
					name={name}
					checked={checked}
					disabled={disabled}
					onChange={handleChange}
					color={color}
					{...props}
				/>
			}
		/>
	);
};
